















import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import CommonSelect from "@/components/common/CommonSelect.vue";
import {get} from "@/context/context";
import {TeacherService} from "@/services/TeacherService";
import {Teacher} from "@/models/Teacher/Teacher";

@Component({
  components: {
    CommonSelect
  },
})
export default class TeacherSelect extends Vue {
  private teacherService: TeacherService = get('teacherService');

  @Prop()
  private value!: string;

  @Prop()
  private label?: string;

  @Prop()
  private name?: string;

  @Prop()
  private rules?: Array<any>;

  @Prop({default: ''})
  private errorMessage!: string;

  @Prop({default: false})
  private disabled!: boolean;

  @Prop({default: null})
  private styleId?: string|null;

  @Prop({default: false})
  private useStyleId?:boolean;

  @Watch('value')
  watchPropValue() {
    this.inputData = this.value;
  }

  @Watch('inputData')
  watchInputData() {
    this.$emit('input', this.inputData)
  }

  @Watch('styleId')
  async watchPropStyleId() {
    this.inputData='';
    await this.listUpdate();
  }

  private inputData: string = '';
  private list: Array<Teacher> = [];

  private async mounted() {
    await this.listUpdate();
  }

  private async listUpdate() {
    if (this.useStyleId) {
      this.list = this.styleId ? await this.teacherService.getListByStyle(this.styleId) : [];
    } else {
      this.list = await this.teacherService.getList();
    }
  }

}
